import React, { useEffect, useMemo } from 'react'
import BasicTabs from '../../../components/tabs/basic-tabs/basic-tabs.component'
import TabPanel from '../../../components/tabs/tab-panel/tab-panel.component'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store'
import { Box, Typography } from '@mui/material'
import { toTitleCase } from '../../../utils/common'
import EquipmentHistory from './equipment-history/equipment-history.component'
import EquipmentDocuments from './equipment-documents/equipment-documents.component'

const EquipmentDetails = () => {
  const [tabsValue, setTabsValue] = React.useState(0)

  const { selectedEquipment } = useSelector(
    (state: RootState) => state.equipments
  )

  const detailTabs = useMemo(
    () => [
      {
        id: 'equipment',
        label: toTitleCase(selectedEquipment.equipmentType || 'Trailer'),
      },
      { id: 'documents', label: 'Documents' },
    ],
    [selectedEquipment.equipmentType]
  )

  useEffect(() => {
    setTabsValue(0)
  }, [selectedEquipment.equipmentId])

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabsValue(newValue)
  }

  if (selectedEquipment.equipmentId === 0) {
    return (
      <Box p={2}>
        <Typography variant="body2" fontWeight={600}>
          Please select equipment to see the details.
        </Typography>
      </Box>
    )
  }

  return (
    <div>
      <div style={{ minHeight: '100%', height: 'calc(100vh - 100px)' }}>
        <BasicTabs
          tabs={detailTabs}
          value={tabsValue}
          handleChange={handleChange}
          scrollableContent
        >
          <TabPanel value={tabsValue} index={0}>
            <EquipmentHistory />
          </TabPanel>
          <TabPanel value={tabsValue} index={1}>
            <EquipmentDocuments />
          </TabPanel>
        </BasicTabs>
      </div>
    </div>
  )
}

export default EquipmentDetails
